// 9fbef606107a605d69c0edbcd8029e5d

import styled, { css } from 'styled-components';

const styles = css`
  border-bottom: 3px solid ${(props) => props.theme.colors.BLACK};
  padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  font-size: ${(props) => props.theme.typography.fontSizes.fs16};
  color: ${(props) => props.theme.colors.TEXT.DARK};
  font-weight: 800;
  text-transform: uppercase;
  display: flex;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    justify-content: space-between;
  }
  .heading-cta {
    text-decoration: underline;
    margin-left: 16px;
    font-family: Nunito;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    margin-right: 19px;
    text-transform: capitalize;
  }
  .actionBtnWrapper {
    display: flex;
    margin-left: auto;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: none;
    }
  }

  .page-heading {
    background-color: white;
  }
  .arrowLeftImg {
    transform: rotate(180deg);
  }
`;

export const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 0px 0px 3px;
  margin: 0px 5px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  background: #f3f3f3;
  border-radius: 50px;
  border: 0px;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    display: none;
  }
`;

export default styles;
